import { createSlice } from '@reduxjs/toolkit';
import { AlertProps } from '@business/interfaces/alert';
import type { RootState } from './store';

export type AlertType = {
  alert: AlertProps;
  scope: string;
};

const initialState: AlertType | null = null;

export const alertSlice = createSlice({
  name: 'alertStateSlice',
  initialState,
  reducers: {
    setAlertDetails: (state, action) => {
      state = {
        alert: action.payload.alert,
        scope: action.payload.scope
      };
      return state;
    },
    resetAlertState: () => {
      return initialState;
    }
  }
});

export const { setAlertDetails, resetAlertState } = alertSlice.actions;

export const getAlertState = (state: RootState) => state.alertStateSlice;
